const cssCalcBetweenViewports = (min: number, max: number, type = 'px', minViewport = 375, maxViewport = 1800) => `
    calc(${min}${type} + (${max} - ${min}) * ((100vw - ${minViewport}px) / (${maxViewport} - ${minViewport})))
`;

export default cssCalcBetweenViewports;
